package com.essntl.features.file.ui.imageinfos

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel

data class ImageInfosState(
    val getFile: State<FileModel> = State(),
    val getAllProposals: State<List<ProposalModel>> = State(),
    val getCountProposalsHistory: State<Long> = State(),
    val getCountOrganizations: State<Long> = State(),
    val getAllTravelAgents: State<List<TravelAgentModel>> = State(),
    val getAllServices: State<List<ServiceModel>> = State(),
    val getAllCategories: State<List<CategoryModel>> = State(),
    val deleteImage: State<Unit> = State(),
    val updateImage: State<FileModel> = State(),
) {
    val isLoading
        get() = getFile.isLoading ||
            getAllProposals.isLoading ||
            getCountProposalsHistory.isLoading ||
            getCountOrganizations.isLoading ||
            getAllTravelAgents.isLoading ||
            getAllServices.isLoading ||
            getAllCategories.isLoading

    val isFailure
        get() = getFile.isFailure ||
            getAllProposals.isFailure ||
            getCountProposalsHistory.isFailure ||
            getCountOrganizations.isFailure ||
            getAllTravelAgents.isFailure ||
            getAllServices.isFailure ||
            getAllCategories.isFailure

    val isDeletable
        get() = getAllProposals.data.orEmpty().isEmpty() &&
            getCountProposalsHistory.data?.toInt() == 0 &&
            getCountOrganizations.data?.toInt() == 0 &&
            getAllTravelAgents.data.orEmpty().isEmpty() &&
            getAllServices.data.orEmpty().isEmpty()
}